export default {
  defaultCoords: ['43.12534352735091', '131.89177036285383'],
  geocode: 'https://geocode-maps.yandex.ru/1.x'
}
